module.exports = __webpack_public_path__ + "static/media/logo.36ed8513.jpg";